<template>
    <tr class="lms__superadmin_users_profile_edit_activitylog_table_item">
      <td class="lms__superadmin_users_profile_edit_activitylog_table_item_event"> {{ eventTitle }} </td>
      <td class="lms__superadmin_users_profile_edit_activitylog_table_item_date"> {{ createdAt }} </td>
      <td class="lms__superadmin_users_profile_edit_activitylog_table_item_notes" v-html="description"></td>
    </tr>
</template>

<script>
export default {
  name: 'lms-superadmin-users-profile-edit-activity-log-table-item',
  props: {
    item: {
      type: Object,
      default: () => {
      }
    }
  },
  computed: {
    eventTitle () {
      return this.item.eventTitle
    },
    createdAt () {
      const fromDate = this.item.createdAt
      return this.toLocaleDateTime(fromDate) + ' - ' + this.toLocaleTime(fromDate)
    },
    description () {
      return this.item.description
    }
  }
}
</script>
